import { useMutation, useQueryClient } from "@tanstack/react-query";

import { $api, fetchClient, invalidate } from "./client";
import type { components } from "./schema";

export type Insight = components["schemas"]["Insight"];

export const useInsights = () => $api.useQuery("get", "/api/v1/insights/");

export function useDismissInsight() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: number) =>
      fetchClient.POST("/api/v1/insights/{id}/dismiss/", {
        params: { path: { id } },
      }),
    onSuccess: () => invalidate(queryClient, "/api/v1/insights/"),
  });
}
